<template>
  <div>
    <DatePicker style="width:200px" format="yyyy-MM-dd"
                placeholder="创建日期筛选"
                class="mb16"
                :options="option"
                v-model="date"
                :clearable=false
                @on-change="changeDate"
    ></DatePicker>

    <div class="mb8">
      <Row class="row lin1 " :gutter=8>

        <Col span="1"> &nbsp;</Col>
        <Col span="5">房间号</Col>
        <Col span="6">价格</Col>
        <Col span="6">租期</Col>
        <Col span="6">付款方式</Col>
      </Row>
      <div class="wrapper-table" style="">
        <Row class="row " :gutter=8
             v-for="(item,index) in roomList" :key="'keyDD'+index">
          <Col span="1">
            <Checkbox v-model="item.isCheck"></Checkbox>

          </Col>
          <Col span="5">{{item.roomNum}}</Col>
          <Col span="6">{{formatMoney(item.roomPrice)}}</Col>
          <Col span="6">
            <Select v-model="item.rentTime" disabled>
              <!--                      <Option value=''>请选择</Option>-->
              <Option v-for="(item,index) in LeaseTimeEnum" :value="item.value" :key="'keyB'+index">{{item.text}}
              </Option>
            </Select>
          </Col>
          <Col span="6">
            <Select v-model="item.payType" disabled>
              <!--                      <Option value=''>请选择</Option>-->
              <Option v-for="(item,index) in payTypeList" :value="item.value" :key="'keyB2'+index">{{item.text}}
              </Option>
            </Select>
          </Col>
        </Row>

      </div>

    </div>

    <div class="mb8" style="text-align: right">
      <Button size="small" type="primary" @click.stop="caculate">计算</Button>
      <!--      <a>计算</a>-->
    </div>
    <div class="seleted mb8">

      <ul v-if="pageData&& pageData.roomRentInfoList.length">
        <li class="bold">
          <span>签约日期</span>
          <span>房间号</span>
          <span>日租金</span>
          <span>日服务费</span>
        </li>
        <li v-for="(item,index) in pageData.roomRentInfoList" :key="'keyO'+index">
          <span>{{item.startDate}} </span>
          <span>{{item.roomNum}}</span>
          <span>{{formatMoney(item.rentPrice)}}</span>
          <span>{{formatMoney(item.servicePrice)}}</span>
        </li>

      </ul>


    </div>
    <div class="mb8" style="text-align: right">
      <Button size="small" type="primary" @click.stop="reset">重置</Button>
      <!--      <a>计算</a>-->
    </div>


  </div>
</template>

<script>
  import {formatDateTime} from "../../../../utils/format";
  import {forRentRoom} from "../../../../api/dashboard";
  import {formatMoney} from "../../../../utils/format";

  export default {
    name: "Condition",
    created() {
      this.setOption()
      this.changeDate()

    },
    props: {
      pageData: {
        type: Object,
        default: null
      },
      projectFid: {
        type: String,
        default: ''
      }

    },
    computed: {
      rommDtoList() {

        let list1 = this.roomList.filter(ele => {
          return ele.isCheck
        })
        let list2 = (this.pageData.roomRentInfoList) ? this.pageData.roomRentInfoList : []
        return list1.concat(list2)
      },

    },
    data() {
      return {
        roomList: [],

        option: null,
        date: '',
        LeaseTimeEnum: [
          {value: 1, text: '年租'},
          {value: 2, text: '月租'},
          {value: 0, text: '尾房'},
        ],
        payTypeList: [
          {value: 1, text: '月付'},
          {value: 3, text: '季付'},
          {value: 6, text: '半年付'},
          {value: 12, text: '年付'},
          {value: 9, text: '一次性付清'},
        ],
      }
    },
    methods: {
      formatMoney:formatMoney,
      changeDate() {
        if (!this.projectFid) {
          return
        }
        let params = {
          projectFid: this.projectFid,
          currentDate: formatDateTime(this.date, false),
          roomDtoList: this.pageData ? this.pageData.roomRentInfoList : []

        }
        forRentRoom(params).then(res => {
          if (!res.data) {
            return
          }
          res.data.forEach(ele => {
            ele['isCheck'] = false
          })

          this.roomList = res.data

        }).catch(error => {

        })
      },
      reset() {
        this.date = formatDateTime(new Date())
        this.$emit('reset')
        let params = {
          projectFid: this.projectFid,
          currentDate: formatDateTime(this.date, false),
          roomDtoList: []

        }
        forRentRoom(params).then(res => {
          if (!res.data) {
            return
          }
          res.data.forEach(ele => {
            ele['isCheck'] = false
          })

          this.roomList = res.data

        }).catch(error => {

        })

      },
      caculate() {
        this.$emit('caculate')

      },
      setOption() {
        this.date = new Date()
        let now = new Date()

        let y = now.getFullYear()
        let m = now.getMonth()

        let maxTime = new Date(y, m + 1, 0)
        this.option = {
          disabledDate(date) {
            return date && date.valueOf() < now.valueOf() - (24 * 60 * 60 * 1000) || date.valueOf() > maxTime.valueOf();
          }
        }

      }
    }
  }
</script>

<style scoped>
  li {
    /*width: 300px;*/
    display: flex;
    justify-content: space-between;
    /*margin-bottom: 10px;*/
    margin: 0 auto 10px auto;
    text-align: center;
  }

  .seleted li span {
    flex: 1;
    text-align: center;

  }

  .seleted {
    background-color: white;
    padding: 20px 0;
    height: 130px;
    border: 1px solid rgb(222, 222, 222);
    margin-right: -4px;
    margin-left: -4px;
    overflow: auto;
    /*border-top: 1px solid rgb(222, 222, 222);*/
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
    box-sizing: border-box;
    background-color: white;
  }

  .lin1 {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  .wrapper-table {
    max-height: 188px;
    overflow: auto;
    margin-left: -4px;
    margin-right: -4px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);


  }

</style>
